// @docs https://[domain]/api/v1/docs
export default {
  Detail: "/pyr/employee-compensations",
};
